import i18n from '../../../i18n.config';

export const getKzLandingsList = () => [
  {
    landingName: 'bathroom',
    isAvailable: true,
    categoryId: 1522,
    presaleType: '',
    presaleSubChannel: '',
    url: '/uslugi/proektirovanie-i-dizayn/sozdayte-vannuyu-komnatu-svoey-mechty/',
    defaultTitle: i18n.t('bathroom-title', { ns: 'landings-info' }),
    addTitle: i18n.t('bathroom-title', { ns: 'landings-info' }),
    description: i18n.t('bathroom-description', { ns: 'landings-info' }),
    imageSrc:
      'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/landings-images/bathroom.jpg/bathroom-1.jpg',
    imageAlt: 'Ванная комната',
    otherSection: ['storage', 'windows', 'ceilings'],
  },
  {
    landingName: 'storage',
    isAvailable: true,
    categoryId: 1524,
    presaleType: '',
    presaleSubChannel: '',
    url: '/uslugi/proektirovanie-i-dizayn/proektirovanie-sistem-hraneniya/',
    defaultTitle: i18n.t('storage-title', { ns: 'landings-info' }),
    addTitle: i18n.t('storage-title', { ns: 'landings-info' }),
    description: i18n.t('storage-description', { ns: 'landings-info' }),
    imageSrc:
      'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/landings-images/storage.jpg/storage-3.jpg',
    imageAlt: 'Системы хранения',
    otherSection: ['bathroom', 'windows', 'ceilings'],
  },
  {
    landingName: 'windows',
    isAvailable: true,
    categoryId: 1525,
    presaleType: 'WINDOW',
    presaleSubChannel: '',
    url: '/uslugi/gotovye-resheniya-pod-klyuch/okna-na-zakaz/',
    defaultTitle: i18n.t('windows-title', { ns: 'landings-info' }),
    addTitle: i18n.t('windows-title', { ns: 'landings-info' }),
    description: i18n.t('windows-description', { ns: 'landings-info' }),
    imageSrc:
      'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/landings-images/windows.jpg/windows-2.jpg',
    imageAlt: 'Окна на заказ',
    otherSection: ['bathroom', 'storage', 'ceilings'],
  },
  {
    landingName: 'ceilings',
    isAvailable: true,
    categoryId: 1527,
    presaleType: 'CEILING',
    presaleSubChannel: '',
    url: '/uslugi/gotovye-resheniya-pod-klyuch/natyazhnye-potolki-na-zakaz/',
    defaultTitle: i18n.t('ceilings-title', { ns: 'landings-info' }),
    addTitle: i18n.t('ceilings-title', { ns: 'landings-info' }),
    description: i18n.t('ceilings-description', { ns: 'landings-info' }),
    imageSrc:
      'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/landings-images/ceilings.jpg/ceilings.jpg',
    imageAlt: 'Натяжные потолки',
    otherSection: ['bathroom', 'storage', 'windows'],
  },
];
